import { createAction } from 'redux-actions';

export const setStudents = createAction('SET_STUDENTS');
export const setCurrentStudent = createAction('SET_CURRENT_STUDENT');
export const SAGA_SET_CURRENT_STUDENT = 'SAGA_SET_CURRENT_STUDENT';
